import {
  drawerWidth,
  transition,
  container
} from "../material-dashboard-react"

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch",
    background: "#f7f7f7",
  },
  content: {
    marginTop: "2px",
    padding: "30px 15px",
    height: "100vh"
  },
  container,
  map: {
    marginTop: "70px"
  }
});

export default appStyle;
